import React from "react";
import Layout from "../components/Layout";
import { FaTwitter } from "react-icons/fa";
import { TwitterFollowButton } from "react-twitter-embed";
import SEO from "../components/SEO";

const contact = () => {
	return (
		<Layout>
			<SEO title="Contact" description="Contact Page" />
			<section className="contact-page">
				<article className="contact-form">
					<h3>Get in touch</h3>
					<p>
						Best place to reach me is Twitter{" "}
						<a href="https://twitter.com/EngineeringUX">
							<FaTwitter />
							@EngineeringUX
						</a>{" "}
						Come say Hi 👋
					</p>
					<TwitterFollowButton screenName={"EngineeringUX"} />
				</article>
			</section>
		</Layout>
	);
};

export default contact;
